import { render, staticRenderFns } from "./RestPass_Form.vue?vue&type=template&id=6f321478&"
import script from "./RestPass_Form.vue?vue&type=script&lang=js&"
export * from "./RestPass_Form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports